import React from 'react';

// Mount component only while shouldMountFn(props) returns true

const withMountCondition = shouldMountFn => BaseComponent => {
  return props => !!shouldMountFn(props) && <BaseComponent {...props} />;
};

export default withMountCondition;
